import { scrollToElementWithStickyOffset } from "../../../common/js/helpers"

export default (commonBasicPlanCheckout) =>
  ({ planSelectionPath, paymentsPath, isTrackVisitCheckout, isAbandonedBasket } = {}) => ({
    // Init basic common checkout functionality

    ...commonBasicPlanCheckout({
      planSelectionPath,
      paymentsPath,
      isTrackVisitCheckout,
      isAbandonedBasket,
    }),

    // Add brand-specific checkout functionality or overwrite common

    init() {
      this.commonInit()
    },

    submitOffer() {
      this.store.internalTracker.setEventToSessionStorage({ clickName: "Get Plan Clicked" })
      this.commonSubmitOffer()
    },

    handleButtonClickWithScrollOffset(options = {}) {
      const { targetSelector = "#offer-container", stickySelector = "#sticky-top-banner", offset = 12, trackingName = "Anchor Clicked" } = options
      this.store.internalTracker.trackClick({ clickName: trackingName })
      scrollToElementWithStickyOffset({ targetSelector, stickySelector, offset })
    },
  })
